import { render, staticRenderFns } from "./newsnav.vue?vue&type=template&id=086bdfde&scoped=true&"
import script from "./newsnav.vue?vue&type=script&lang=js&"
export * from "./newsnav.vue?vue&type=script&lang=js&"
import style0 from "./newsnav.vue?vue&type=style&index=0&id=086bdfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086bdfde",
  null
  
)

export default component.exports